module.exports = __webpack_public_path__ + "static/media/A5.977dbd81.jpg";